import { useNavigation } from 'expo-router';
import { useLayoutEffect } from 'react';
import { ScrollView, StyleSheet, View } from 'react-native';

import GoBackButton from '@/components/buttons/GoBackButton';
import Text from '@/components/Text';
import Title from '@/components/Title';
import { FAQS } from '@/constants/config';
import { i18n } from '@/utils/i18n';

export type QuestionAnswer = {
  question: string;
  answer: string;
};

const FAQ = () => {
  const navigation = useNavigation();

  //Locales
  const title = i18n.t('settings.screen_names.faq');

  useLayoutEffect(() => {
    navigation.setOptions({
      headerTitle: () => <Title label={title} />,
      headerLeft: () => <GoBackButton />
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigation]);

  const faqRow = (index: number, faq: QuestionAnswer) => (
    <View key={index} style={styles.faqRow}>
      <Text style={styles.question} fontWeight="700">
        {faq.question}
      </Text>
      <Text style={styles.answer} fontWeight="450">
        {faq.answer}
      </Text>
    </View>
  );

  return (
    <ScrollView contentContainerStyle={styles.contentStyle} showsVerticalScrollIndicator={false}>
      {FAQS.map((faq, index) => faqRow(index, faq))}
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  contentStyle: {
    paddingHorizontal: 18,
    flexDirection: 'column',
    gap: 15
  },

  faqRow: {
    flex: 1,
    flexDirection: 'column',
    rowGap: 5
  },

  question: {
    fontSize: 14,
    color: 'black'
  },

  answer: {
    flex: 1,
    fontSize: 14,
    color: 'rgba(0,0,0,0.6)'
  }
});

export default FAQ;
